import PersonIcon from '@mui/icons-material/Person'
import { Avatar, Stack } from '@mui/material'
import { ColoursObj, Icon, Typography } from '@eventr/common-storybook'
import { FC, useState } from 'react'
import { ArrowFlip } from '../../../assets/animated/arrowFlip'

type props = {
    header?: string
    nameList?: string[]
    showSecret?: boolean
}

export const PersonListExpander: FC<props> = ({
    header,
    nameList,
    showSecret,
}) => {
    const [open, setOpen] = useState<boolean>(false)

    return (
        <Stack direction="column">
            <Stack
                direction="row"
                display="grid"
                gridTemplateColumns="auto 1fr auto"
                width="90vw"
                gap="16px"
                alignItems="center"
                onClick={() => {
                    setOpen(!open)
                }}
            >
                <Avatar
                    sx={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: 'var(--primaryColor)',
                    }}
                >
                    <Icon name="Group" />
                </Avatar>
                <Typography color={ColoursObj.core.primary}>
                    {header}
                </Typography>
                <ArrowFlip open={open} colour={ColoursObj.core.primary} />
            </Stack>
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    gridTemplateRows: open ? '1fr' : '0fr',
                    transition: 'ease 0.2s',
                }}
            >
                <Stack overflow="hidden" gap="8px" padding="16px 0 0 16px">
                    {nameList?.map((name, index) => {
                        const [preffix, suffix] = name.split(' - ')
                        return (
                            <Stack
                                direction="row"
                                key={index}
                                gap="16px"
                                alignItems="center"
                            >
                                <Avatar
                                    sx={{
                                        width: '32px',
                                        height: '32px',
                                        backgroundColor: 'var(--iconYellow)',
                                    }}
                                >
                                    <PersonIcon
                                        sx={{
                                            color: ColoursObj.core.primary,
                                            width: '16px',
                                        }}
                                    />
                                </Avatar>
                                <Typography color={ColoursObj.core.primary}>
                                    {preffix}
                                    {showSecret &&
                                        ' - ' + (suffix ? suffix : '')}
                                </Typography>
                            </Stack>
                        )
                    })}
                </Stack>
            </div>
        </Stack>
    )
}
